import React, { useState, useEffect, useRef } from "react";
import "./BuyingModel.css";
import { Button } from "@material-ui/core";
import {
  getFirestore,
  collection,
  onSnapshot,
  doc,
  getDocs,
  updateDoc,
  setDoc,
  serverTimestamp,
  increment,
} from "firebase/firestore";

import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";

import { storage } from "../../../firebase";
import inputErrorMessage from "../../../Component/InputErrorMessage.json";

import {
  getDownloadURL,
  getStorage,
  ref,
  uploadBytes,
  uploadBytesResumable,
} from "firebase/storage";

import { useNavigate, useParams } from "react-router-dom";
import SpinnerSVG from "../../../spinner.svg";
import axios from "../../../axios";
import { useStateValue } from "../../../StateProvider";
import BuyingModelInput from "../../../Component/BuyingModelInput";
import Modal from "../../../Modal";

const GROUP_DISCOUNT = 0;
const GROUP_SIZE = 0;

const db = getFirestore();

var regular_tickets_available = -1;
var early_tickets_available = -1;

const maxTicket = 15;

const teamPossibility = ["Admin", "Exec Team", "Events Team", "IR"];

const vaccineProofSection = false;

const handleNextPage = (setPage) => {
  setPage((page) => page + 1);
};

const handlePreviousPage = (setPage) => {
  setPage((page) => page - 1);
};

// TODO: Form Validation for all fields

function BuyingModel({ modelOpen, eventId }) {
  // Page counter
  const [page, setPage] = useState(1);
  const [show, setShow] = useState(false);

  // Timer
  const [min, setMin] = useState(10);
  const [sec, setSec] = useState(0);

  // Coming Soon constants
  const [comingSoon, setComingSoon] = useState(false);
  // Early Team Release constants
  const [earlyTeamRelease, setEarlyTeamRelease] = useState(false);

  // Roles
  const [{ user }, dispatch] = useStateValue();
  const [role, setRole] = useState("");

  // Regular Ticket Variables
  const [regularTicketAmount, setRegularTicketAmount] = useState(0);
  const [regularTicketAvailable, setRegularTicketAvailable] = useState(-1);
  const [regularTicketWaitingList, setRegularTicketWaitingList] = useState(-1);
  const [regularTicketsBought, setRegularTicketsBought] = useState(0);
  const [previousRegularTicketsBought, setPreviousRegularTicketsBought] =
    useState(0);

  // Early Bird Ticket Variables
  const [earlyBirdTicketAmount, setEarlyBirdTicketAmount] = useState(0);
  const [earlyBirdTicketAvailable, setEarlyBirdTicketAvailable] = useState(-1);
  const [earlyBirdTicketWaitingList, setEarlyBirdTicketWaitingList] =
    useState(-1);
  const [earlyBirdTicketsBought, setEarlyBirdTicketsBought] = useState(0);
  const [previousEarlyBirdTicketsBought, setPreviousEarlyBirdTicketsBought] =
    useState(0);

  // Regular Ticket Id
  const [regularTicketId, setRegularTicketId] = useState("");
  // Early Bird Ticket Id
  const [earlyBirdTicketId, setEarlyBirdTicketId] = useState("");

  // Ticket Status
  const [ticketsStatus, setTicketsStatus] = useState(false);

  // Collection Refs
  const earlyBirdCollectionRef = collection(
    db,
    "events",
    eventId.id,
    "Early Bird"
  );
  const regularTicketCollectionRef = collection(
    db,
    "events",
    eventId.id,
    "Regular Ticket"
  );

  const eventRef = doc(collection(db, "events"), eventId.id);

  const [regularUserInfo, setRegularUserInfo] = useState({});
  const [earlyUserInfo, setEarlyUserInfo] = useState({});

  const [totalTicketAmount, setTotalTicketAmount] = useState(0);

  const [eventName, setEventName] = useState("");

  const [regularVaccineProof, setRegularVaccineProof] = useState({});
  const [earlyVaccineProof, setEarlyVaccineProof] = useState({});

  const [eventImgUrl, setEventImgUrl] = useState("");

  const [grossSales, setGrossSales] = useState(0);

  useEffect(() => {
    if (user) {
      const userCollectionRef = doc(collection(db, "users"), user?.uid);
      const unsubscribe = onSnapshot(userCollectionRef, (doc) => {
        setRole(doc.data()?.role);
      });
      return () => unsubscribe();
    }
  }, [user]);

  const handleClose = () => {
    if (
      (page === 8 && vaccineProofSection) ||
      (page === 7 && !vaccineProofSection)
    ) {
      modelOpen(false);
      return;
    }
    if (previousRegularTicketsBought !== 0) {
      updateDoc(eventRef, {
        // RegularTickets: {
        //   price: regularTicketAmount,
        //   ticketsAvailable:
        //     regularTicketAvailable,
        //   waitingList: regularTicketWaitingList - previousRegularTicketsBought,
        // },
        RegularTicketWaitingList: increment(-previousRegularTicketsBought),
      });
    }
    if (previousEarlyBirdTicketsBought !== 0) {
      updateDoc(eventRef, {
        // EarlyBirdTicket: {
        //   price: earlyBirdTicketAmount,
        //   ticketsAvailable:
        //     earlyBirdTicketAvailable,
        //   waitingList:
        //     earlyBirdTicketWaitingList - previousEarlyBirdTicketsBought,
        // },
        EarlyBirdTicketWaitingList: increment(-previousEarlyBirdTicketsBought),
      });
    }
    modelOpen(false);
  };

  // useInterval(() => {
  //   if (regularTicketAvailable !== -1 && earlyBirdTicketAvailable !== -1) {
  //     if (sec === 0 && min > 0) {
  //       setMin((min) => min - 1);
  //       setSec(59);
  //     } else if (sec === 0 && min === 0) {
  //       handleClose();
  //     } else {
  //       setSec((sec) => sec - 1);
  //     }
  //   }
  // }, 1000);

  // Reset the variables
  useEffect(() => {
    // Firebase server timestamp

    // const unsubscribe = onSnapshot(earlyBirdCollectionRef, (snap) => {
    //   try {
    //     setEarlyBirdTicketId(snap.docs[0].id);
    //     setEarlyBirdTicketAmount(snap.docs[0].data()?.price);
    //     setEarlyBirdTicketAvailable(snap.docs[0].data()?.ticketsAvailable);
    //     setEarlyBirdTicketWaitingList(snap.docs[0].data()?.waitingList);

    //     // early_ticket_price = snap.docs[0].data()?.price;
    //     early_tickets_available = snap.docs[0].data()?.ticketsAvailable;
    //     // early_waitingList = snap.docs[0].data()?.waitingList;
    //   } catch (error) {
    //     console.log("No early Bird Ticket", error);
    //   }
    // });

    // const unsubscribe1 = onSnapshot(regularTicketCollectionRef, (snap) => {
    //   try {
    //     setRegularTicketId(snap.docs[0].id);
    //     setRegularTicketAmount(snap.docs[0].data()?.price);
    //     setRegularTicketAvailable(snap.docs[0].data()?.ticketsAvailable);
    //     setRegularTicketWaitingList(snap.docs[0].data()?.waitingList);

    //     // regular_ticket_price = snap.docs[0].data()?.price;

    //     // regular_waitingList = snap.docs[0].data()?.waitingList;

    //     // try {
    //     //   if (
    //     //     (regular_tickets_available === 0 &&
    //     //       early_tickets_available === 0) ||
    //     //     (regular_tickets_available === -1 && early_tickets_available === -1)
    //     //   ) {
    //     //     document.getElementById("ticket_selection_btn").style.display =
    //     //       "none";
    //     //   } else {
    //     //     document.getElementById("ticket_selection_btn").style.display =
    //     //       "block";
    //     //   }
    //     // } catch (e) {
    //     //   // console.log("Couldn't find the button!");
    //     // }
    //   } catch (error) {
    //     console.log("No regular Ticket");
    //   }
    // });

    const unsubscribe2 = onSnapshot(eventRef, (snap) => {
      setTicketsStatus(snap.data()?.ticketsStatus);
      setEventName(snap.data()?.eventName);
      setEventImgUrl(snap.data()?.eventImgUrl);
      setGrossSales(snap.data()?.grossSales);
      setComingSoon(snap.data()?.comingSoon);
      setEarlyTeamRelease(snap.data()?.earlyTeamRelease);
      // To get regular tickets information
      try {
        // setRegularTicketId(snap.data().id);
        setRegularTicketAmount(snap.data()?.RegularTicketPrice);
        setRegularTicketAvailable(snap.data()?.RegularTicketsAvailable);
        setRegularTicketWaitingList(snap.data()?.RegularTicketWaitingList);
      } catch (e) {
        console.log("No regular Ticket");
      }

      // To get early bird tickets information
      try {
        // setRegularTicketId(snap.data().id);
        setEarlyBirdTicketAmount(snap.data()?.EarlyBirdTicketPrice);
        setEarlyBirdTicketAvailable(snap.data()?.EarlyBirdTicketsAvailable);
        setEarlyBirdTicketWaitingList(snap.data()?.EarlyBirdTicketWaitingList);
      } catch (e) {
        console.log("No Early Bird Ticket");
      }

      // Check if there is no early bird ticket or regular tickets
      // regular_tickets_available = snap.data()?.RegularTickets?.ticketsAvailable;
      // early_tickets_available = snap.data()?.EarlyBirdTicket?.ticketsAvailable;
      // try {
      //   if (
      //     (regular_tickets_available === 0 && early_tickets_available === 0) ||
      //     (regular_tickets_available === -1 && early_tickets_available === -1)
      //   ) {
      //     document.getElementById("ticket_selection_btn").style.display =
      //       "none";
      //   } else {
      //     document.getElementById("ticket_selection_btn").style.display =
      //       "block";
      //   }
      // } catch (e) {
      //   // console.log("Couldn't find the button!");
      // }
    });

    return () => {
      regular_tickets_available = -1;
      early_tickets_available = -1;

      handleClose();

      // unsubscribe();
      // unsubscribe1();
      unsubscribe2();
    };
  }, [eventId]);

  return (
    <div className="buyingModel">
      <div
        className="buyingModel_container"
        data-aos="zoom-in"
        data-aos-duration="500"
      >
        <div className="buyingModal_header">
          {/* <a id="time_remaining">
            <img src="/Images/Event/clock.png" className="clock_icon" />: {min}m{" "}
            {sec < 10 ? `0${sec}s` : `${sec}s`}
          </a> */}
          <img src="/Images/Login/close.png" onClick={handleClose} />
        </div>

        {ticketsStatus === false ? (
          // If the ticket status is false means the event is not selling any tickets yet.
          <SoldOut />
        ) : (
          // Id the ticket status is true. This means the event is selling tickets.
          <>
            {/* Check to see if the vaccineProof is set to true */}
            {vaccineProofSection === true ? (
              <>
                {comingSoon === true ? (
                  // If the event is set to coming soon then we check to see if the team is set to true.
                  <>
                    {earlyTeamRelease === true ? (
                      // If team is set to true then we check to see if the user is one of the respective roles.
                      <>
                        {teamPossibility.includes(role) ? (
                          <div className="buyingModel_body">
                            {page === 1 && (
                              <div
                                className="page_one"
                                data-aos="fade-out"
                                data-aos-duration="1000"
                              >
                                {/* {console.log("Vaccine Proof early Release!")} */}
                                <MemoizedOnboardingOne
                                  eventId={eventId}
                                  ticketStat={ticketsStatus}
                                  availableRegularTicket={
                                    regularTicketAvailable
                                  }
                                  availableEarlyTicket={
                                    earlyBirdTicketAvailable
                                  }
                                  regularTicketPrice={regularTicketAmount}
                                  earlyTicketPrice={earlyBirdTicketAmount}
                                  setPage={setPage}
                                />
                              </div>
                            )}
                            {page === 2 && (
                              <div
                                className="page_one"
                                data-aos="fade-in"
                                data-aos-duration="1000"
                              >
                                <MemorizedTicketSelectionPage
                                  eventId={eventId}
                                  eventRef={eventRef}
                                  available_regular_ticket={
                                    regularTicketAvailable
                                  }
                                  available_early_ticket={
                                    earlyBirdTicketAvailable
                                  }
                                  regular_ticket_price={regularTicketAmount}
                                  early_ticket_price={earlyBirdTicketAmount}
                                  setPage={setPage}
                                  regularTicketId={regularTicketId}
                                  earlyBirdTicketId={earlyBirdTicketId}
                                  waitingListRegular={regularTicketWaitingList}
                                  waitingListEarlyBird={
                                    earlyBirdTicketWaitingList
                                  }
                                  // Regular and Early Bought
                                  regularTicketsBought={regularTicketsBought}
                                  earlyBirdTicketsBought={
                                    earlyBirdTicketsBought
                                  }
                                  setRegularTicketsBought={
                                    setRegularTicketsBought
                                  }
                                  setEarlyBirdTicketsBought={
                                    setEarlyBirdTicketsBought
                                  }
                                  // Previous Regular and Early Bought
                                  previousRegularTicketsBought={
                                    previousRegularTicketsBought
                                  }
                                  previousEarlyBirdTicketsBought={
                                    previousEarlyBirdTicketsBought
                                  }
                                  setPreviousRegularTicketsBought={
                                    setPreviousRegularTicketsBought
                                  }
                                  setPreviousEarlyBirdTicketsBought={
                                    setPreviousEarlyBirdTicketsBought
                                  }
                                />
                              </div>
                            )}
                            {page === 3 && (
                              <div
                                className="page_one"
                                data-aos="fade-in"
                                data-aos-duration="1000"
                              >
                                <MemorizedUserInformationPage
                                  eventId={eventId}
                                  setPage={setPage}
                                  setRegularUserInfo={setRegularUserInfo}
                                  setEarlyUserInfo={setEarlyUserInfo}
                                  regularUserInfo={regularUserInfo}
                                  earlyUserInfo={earlyUserInfo}
                                  regularTicketsBought={regularTicketsBought}
                                  earlyBirdTicketsBought={
                                    earlyBirdTicketsBought
                                  }
                                  previousRegularTicketsBought={
                                    previousRegularTicketsBought
                                  }
                                  previousEarlyBirdTicketsBought={
                                    previousEarlyBirdTicketsBought
                                  }
                                />
                              </div>
                            )}
                            {page === 4 && (
                              <div
                                className="page_one"
                                data-aos="fade-in"
                                data-aos-duration="1000"
                              >
                                <VaccineProof
                                  eventId={eventId}
                                  setPage={setPage}
                                  // Regular and Early Bought
                                  regularTicketsBought={regularTicketsBought}
                                  earlyBirdTicketsBought={
                                    earlyBirdTicketsBought
                                  }
                                  // User Information
                                  regularUserInfo={regularUserInfo}
                                  earlyUserInfo={earlyUserInfo}
                                  setRegularUserInfo={setRegularUserInfo}
                                  setEarlyUserInfo={setEarlyUserInfo}
                                  // Vaccine Proof
                                  setRegularVaccineProof={
                                    setRegularVaccineProof
                                  }
                                  setEarlyVaccineProof={setEarlyVaccineProof}
                                  regularVaccineProof={regularVaccineProof}
                                  earlyVaccineProof={earlyVaccineProof}
                                />
                              </div>
                            )}
                            {page === 5 && (
                              <div
                                className="page_one"
                                data-aos="fade-in"
                                data-aos-duration="1000"
                              >
                                <TermsCondition
                                  eventId={eventId}
                                  setPage={setPage}
                                  eventName={eventName}
                                  regularUserInfo={regularUserInfo}
                                  earlyUserInfo={earlyUserInfo}
                                />
                              </div>
                            )}

                            {page === 6 && (
                              <div
                                className="page_one"
                                data-aos="fade-in"
                                data-aos-duration="1000"
                              >
                                <ReviewDetails
                                  eventId={eventId}
                                  setPage={setPage}
                                  regularUserInfo={regularUserInfo}
                                  earlyUserInfo={earlyUserInfo}
                                  regularTicketAmount={regularTicketAmount}
                                  earlyBirdTicketAmount={earlyBirdTicketAmount}
                                  totalTicketAmount={totalTicketAmount}
                                  setTotalTicketAmount={setTotalTicketAmount}
                                  regularTicketsBought={regularTicketsBought}
                                  earlyBirdTicketsBought={
                                    earlyBirdTicketsBought
                                  }
                                />
                              </div>
                            )}
                            {/* // ! We can maybe check here for if the ticket is available for the selected number... (Vaccine Proof then) */}
                            {page === 7 && (
                              <div
                                className="page_one"
                                data-aos="fade-in"
                                data-aos-duration="1000"
                              >
                                <Payment
                                  eventId={eventId}
                                  setPage={setPage}
                                  setShow={setShow}
                                  regularUserInfo={regularUserInfo}
                                  earlyUserInfo={earlyUserInfo}
                                  regularTicketAmount={regularTicketAmount}
                                  earlyBirdTicketAmount={earlyBirdTicketAmount}
                                  totalTicketAmount={totalTicketAmount}
                                  eventName={eventName}
                                  regularTicketsBought={regularTicketsBought}
                                  earlyBirdTicketsBought={
                                    earlyBirdTicketsBought
                                  }
                                  setEarlyBirdTicketsBought={
                                    setEarlyBirdTicketsBought
                                  }
                                  setRegularTicketsBought={
                                    setRegularTicketsBought
                                  }
                                  regularVaccineProof={regularVaccineProof}
                                  earlyVaccineProof={earlyVaccineProof}
                                  setRegularUserInfo={setRegularUserInfo}
                                  setEarlyUserInfo={setEarlyUserInfo}
                                  waitingListRegular={regularTicketWaitingList}
                                  waitingListEarlyBird={
                                    earlyBirdTicketWaitingList
                                  }
                                  previousRegularTicketsBought={
                                    previousRegularTicketsBought
                                  }
                                  previousEarlyBirdTicketsBought={
                                    previousEarlyBirdTicketsBought
                                  }
                                  setPreviousRegularTicketsBought={
                                    setPreviousRegularTicketsBought
                                  }
                                  setPreviousEarlyBirdTicketsBought={
                                    setPreviousEarlyBirdTicketsBought
                                  }
                                  regularTicketId={regularTicketId}
                                  earlyBirdTicketId={earlyBirdTicketId}
                                  setRegularTicketId={setRegularTicketId}
                                  setEarlyBirdTicketId={setEarlyBirdTicketId}
                                  eventImgUrl={eventImgUrl}
                                  eventRef={eventRef}
                                  regularTicketAvailable={
                                    regularTicketAvailable
                                  }
                                  earlyBirdTicketAvailable={
                                    earlyBirdTicketAvailable
                                  }
                                />
                              </div>
                            )}
                            {page === 8 && (
                              <div
                                className="page_one"
                                data-aos="fade-in"
                                data-aos-duration="1000"
                              >
                                <SuccessPage
                                  eventId={eventId}
                                  setPage={setPage}
                                />
                              </div>
                            )}
                          </div>
                        ) : (
                          <ComingSoon />
                        )}
                      </>
                    ) : (
                      <ComingSoon />
                    )}
                  </>
                ) : (
                  <div className="buyingModel_body">
                    {page === 1 && (
                      <div
                        className="page_one"
                        data-aos="fade-out"
                        data-aos-duration="1000"
                      >
                        {/* {console.log("Vaccine Proof early Release!")} */}
                        <MemoizedOnboardingOne
                          eventId={eventId}
                          ticketStat={ticketsStatus}
                          availableRegularTicket={regularTicketAvailable}
                          availableEarlyTicket={earlyBirdTicketAvailable}
                          regularTicketPrice={regularTicketAmount}
                          earlyTicketPrice={earlyBirdTicketAmount}
                          setPage={setPage}
                        />
                      </div>
                    )}
                    {page === 2 && (
                      <div
                        className="page_one"
                        data-aos="fade-in"
                        data-aos-duration="1000"
                      >
                        <MemorizedTicketSelectionPage
                          eventId={eventId}
                          eventRef={eventRef}
                          available_regular_ticket={regularTicketAvailable}
                          available_early_ticket={earlyBirdTicketAvailable}
                          regular_ticket_price={regularTicketAmount}
                          early_ticket_price={earlyBirdTicketAmount}
                          setPage={setPage}
                          regularTicketId={regularTicketId}
                          earlyBirdTicketId={earlyBirdTicketId}
                          waitingListRegular={regularTicketWaitingList}
                          waitingListEarlyBird={earlyBirdTicketWaitingList}
                          // Regular and Early Bought
                          regularTicketsBought={regularTicketsBought}
                          earlyBirdTicketsBought={earlyBirdTicketsBought}
                          setRegularTicketsBought={setRegularTicketsBought}
                          setEarlyBirdTicketsBought={setEarlyBirdTicketsBought}
                          // Previous Regular and Early Bought
                          previousRegularTicketsBought={
                            previousRegularTicketsBought
                          }
                          previousEarlyBirdTicketsBought={
                            previousEarlyBirdTicketsBought
                          }
                          setPreviousRegularTicketsBought={
                            setPreviousRegularTicketsBought
                          }
                          setPreviousEarlyBirdTicketsBought={
                            setPreviousEarlyBirdTicketsBought
                          }
                        />
                      </div>
                    )}
                    {page === 3 && (
                      <div
                        className="page_one"
                        data-aos="fade-in"
                        data-aos-duration="1000"
                      >
                        <MemorizedUserInformationPage
                          eventId={eventId}
                          setPage={setPage}
                          setRegularUserInfo={setRegularUserInfo}
                          setEarlyUserInfo={setEarlyUserInfo}
                          regularUserInfo={regularUserInfo}
                          earlyUserInfo={earlyUserInfo}
                          regularTicketsBought={regularTicketsBought}
                          earlyBirdTicketsBought={earlyBirdTicketsBought}
                          previousRegularTicketsBought={
                            previousRegularTicketsBought
                          }
                          previousEarlyBirdTicketsBought={
                            previousEarlyBirdTicketsBought
                          }
                        />
                      </div>
                    )}
                    {page === 4 && (
                      <div
                        className="page_one"
                        data-aos="fade-in"
                        data-aos-duration="1000"
                      >
                        <VaccineProof
                          eventId={eventId}
                          setPage={setPage}
                          // Regular and Early Bought
                          regularTicketsBought={regularTicketsBought}
                          earlyBirdTicketsBought={earlyBirdTicketsBought}
                          // User Information
                          regularUserInfo={regularUserInfo}
                          earlyUserInfo={earlyUserInfo}
                          setRegularUserInfo={setRegularUserInfo}
                          setEarlyUserInfo={setEarlyUserInfo}
                          // Vaccine Proof
                          setRegularVaccineProof={setRegularVaccineProof}
                          setEarlyVaccineProof={setEarlyVaccineProof}
                          regularVaccineProof={regularVaccineProof}
                          earlyVaccineProof={earlyVaccineProof}
                        />
                      </div>
                    )}
                    {page === 5 && (
                      <div
                        className="page_one"
                        data-aos="fade-in"
                        data-aos-duration="1000"
                      >
                        <TermsCondition
                          eventId={eventId}
                          setPage={setPage}
                          eventName={eventName}
                          regularUserInfo={regularUserInfo}
                          earlyUserInfo={earlyUserInfo}
                        />
                      </div>
                    )}

                    {page === 6 && (
                      <div
                        className="page_one"
                        data-aos="fade-in"
                        data-aos-duration="1000"
                      >
                        <ReviewDetails
                          eventId={eventId}
                          setPage={setPage}
                          regularUserInfo={regularUserInfo}
                          earlyUserInfo={earlyUserInfo}
                          regularTicketAmount={regularTicketAmount}
                          earlyBirdTicketAmount={earlyBirdTicketAmount}
                          totalTicketAmount={totalTicketAmount}
                          setTotalTicketAmount={setTotalTicketAmount}
                          regularTicketsBought={regularTicketsBought}
                          earlyBirdTicketsBought={earlyBirdTicketsBought}
                        />
                      </div>
                    )}
                    {/* // ! We can maybe check here for if the ticket is available for the selected number... (Vaccine Proof then) */}
                    {page === 7 && (
                      <div
                        className="page_one"
                        data-aos="fade-in"
                        data-aos-duration="1000"
                      >
                        <Payment
                          eventId={eventId}
                          setPage={setPage}
                          setShow={setShow}
                          regularUserInfo={regularUserInfo}
                          earlyUserInfo={earlyUserInfo}
                          regularTicketAmount={regularTicketAmount}
                          earlyBirdTicketAmount={earlyBirdTicketAmount}
                          totalTicketAmount={totalTicketAmount}
                          eventName={eventName}
                          regularTicketsBought={regularTicketsBought}
                          earlyBirdTicketsBought={earlyBirdTicketsBought}
                          setEarlyBirdTicketsBought={setEarlyBirdTicketsBought}
                          setRegularTicketsBought={setRegularTicketsBought}
                          regularVaccineProof={regularVaccineProof}
                          earlyVaccineProof={earlyVaccineProof}
                          setRegularUserInfo={setRegularUserInfo}
                          setEarlyUserInfo={setEarlyUserInfo}
                          waitingListRegular={regularTicketWaitingList}
                          waitingListEarlyBird={earlyBirdTicketWaitingList}
                          previousRegularTicketsBought={
                            previousRegularTicketsBought
                          }
                          previousEarlyBirdTicketsBought={
                            previousEarlyBirdTicketsBought
                          }
                          setPreviousRegularTicketsBought={
                            setPreviousRegularTicketsBought
                          }
                          setPreviousEarlyBirdTicketsBought={
                            setPreviousEarlyBirdTicketsBought
                          }
                          regularTicketId={regularTicketId}
                          earlyBirdTicketId={earlyBirdTicketId}
                          setRegularTicketId={setRegularTicketId}
                          setEarlyBirdTicketId={setEarlyBirdTicketId}
                          eventImgUrl={eventImgUrl}
                          eventRef={eventRef}
                          regularTicketAvailable={regularTicketAvailable}
                          earlyBirdTicketAvailable={earlyBirdTicketAvailable}
                        />
                      </div>
                    )}
                    {page === 8 && (
                      <div
                        className="page_one"
                        data-aos="fade-in"
                        data-aos-duration="1000"
                      >
                        <SuccessPage eventId={eventId} setPage={setPage} />
                      </div>
                    )}
                  </div>
                )}
              </>
            ) : (
              // If vaccineProofSection is false
              <>
                {comingSoon === true ? (
                  // If the event is set to coming soon then we check to see if the team is set to true.
                  <>
                    {earlyTeamRelease === true ? (
                      // If team is set to true then we check to see if the user is one of the respective roles.
                      <>
                        {teamPossibility.includes(role) ? (
                          <div className="buyingModel_body">
                            {page === 1 && (
                              <div
                                className="page_one"
                                data-aos="fade-out"
                                data-aos-duration="1000"
                              >
                                {/* {console.log("Hello Team Early Release!")} */}
                                <MemoizedOnboardingOne
                                  eventId={eventId}
                                  ticketStat={ticketsStatus}
                                  availableRegularTicket={
                                    regularTicketAvailable
                                  }
                                  availableEarlyTicket={
                                    earlyBirdTicketAvailable
                                  }
                                  regularTicketPrice={regularTicketAmount}
                                  earlyTicketPrice={earlyBirdTicketAmount}
                                  setPage={setPage}
                                />
                              </div>
                            )}
                            {page === 2 && (
                              <div
                                className="page_one"
                                data-aos="fade-in"
                                data-aos-duration="1000"
                              >
                                <MemorizedTicketSelectionPage
                                  eventId={eventId}
                                  eventRef={eventRef}
                                  available_regular_ticket={
                                    regularTicketAvailable
                                  }
                                  available_early_ticket={
                                    earlyBirdTicketAvailable
                                  }
                                  regular_ticket_price={regularTicketAmount}
                                  early_ticket_price={earlyBirdTicketAmount}
                                  setPage={setPage}
                                  regularTicketId={regularTicketId}
                                  earlyBirdTicketId={earlyBirdTicketId}
                                  waitingListRegular={regularTicketWaitingList}
                                  waitingListEarlyBird={
                                    earlyBirdTicketWaitingList
                                  }
                                  // Regular and Early Bought
                                  regularTicketsBought={regularTicketsBought}
                                  earlyBirdTicketsBought={
                                    earlyBirdTicketsBought
                                  }
                                  setRegularTicketsBought={
                                    setRegularTicketsBought
                                  }
                                  setEarlyBirdTicketsBought={
                                    setEarlyBirdTicketsBought
                                  }
                                  // Previous Regular and Early Bought
                                  previousRegularTicketsBought={
                                    previousRegularTicketsBought
                                  }
                                  previousEarlyBirdTicketsBought={
                                    previousEarlyBirdTicketsBought
                                  }
                                  setPreviousRegularTicketsBought={
                                    setPreviousRegularTicketsBought
                                  }
                                  setPreviousEarlyBirdTicketsBought={
                                    setPreviousEarlyBirdTicketsBought
                                  }
                                />
                              </div>
                            )}
                            {page === 3 && (
                              <div
                                className="page_one"
                                data-aos="fade-in"
                                data-aos-duration="1000"
                              >
                                <MemorizedUserInformationPage
                                  eventId={eventId}
                                  setPage={setPage}
                                  setRegularUserInfo={setRegularUserInfo}
                                  setEarlyUserInfo={setEarlyUserInfo}
                                  regularUserInfo={regularUserInfo}
                                  earlyUserInfo={earlyUserInfo}
                                  regularTicketsBought={regularTicketsBought}
                                  earlyBirdTicketsBought={
                                    earlyBirdTicketsBought
                                  }
                                  previousRegularTicketsBought={
                                    previousRegularTicketsBought
                                  }
                                  previousEarlyBirdTicketsBought={
                                    previousEarlyBirdTicketsBought
                                  }
                                />
                              </div>
                            )}
                            {page === 4 && (
                              <div
                                className="page_one"
                                data-aos="fade-in"
                                data-aos-duration="1000"
                              >
                                <TermsCondition
                                  eventId={eventId}
                                  setPage={setPage}
                                  eventName={eventName}
                                  regularUserInfo={regularUserInfo}
                                  earlyUserInfo={earlyUserInfo}
                                />
                              </div>
                            )}

                            {page === 5 && (
                              <div
                                className="page_one"
                                data-aos="fade-in"
                                data-aos-duration="1000"
                              >
                                <ReviewDetails
                                  eventId={eventId}
                                  setPage={setPage}
                                  regularUserInfo={regularUserInfo}
                                  earlyUserInfo={earlyUserInfo}
                                  regularTicketAmount={regularTicketAmount}
                                  earlyBirdTicketAmount={earlyBirdTicketAmount}
                                  totalTicketAmount={totalTicketAmount}
                                  setTotalTicketAmount={setTotalTicketAmount}
                                  regularTicketsBought={regularTicketsBought}
                                  earlyBirdTicketsBought={
                                    earlyBirdTicketsBought
                                  }
                                />
                              </div>
                            )}
                            {/* // ! We can maybe check here for if the ticket is available for the selected number... */}
                            {page === 6 && (
                              <div
                                className="page_one"
                                data-aos="fade-in"
                                data-aos-duration="1000"
                              >
                                <Payment
                                  eventId={eventId}
                                  setPage={setPage}
                                  setShow={setShow}
                                  regularUserInfo={regularUserInfo}
                                  earlyUserInfo={earlyUserInfo}
                                  regularTicketAmount={regularTicketAmount}
                                  earlyBirdTicketAmount={earlyBirdTicketAmount}
                                  totalTicketAmount={totalTicketAmount}
                                  eventName={eventName}
                                  regularTicketsBought={regularTicketsBought}
                                  earlyBirdTicketsBought={
                                    earlyBirdTicketsBought
                                  }
                                  setEarlyBirdTicketsBought={
                                    setEarlyBirdTicketsBought
                                  }
                                  setRegularTicketsBought={
                                    setRegularTicketsBought
                                  }
                                  regularVaccineProof={regularVaccineProof}
                                  earlyVaccineProof={earlyVaccineProof}
                                  setRegularUserInfo={setRegularUserInfo}
                                  setEarlyUserInfo={setEarlyUserInfo}
                                  waitingListRegular={regularTicketWaitingList}
                                  waitingListEarlyBird={
                                    earlyBirdTicketWaitingList
                                  }
                                  previousRegularTicketsBought={
                                    previousRegularTicketsBought
                                  }
                                  previousEarlyBirdTicketsBought={
                                    previousEarlyBirdTicketsBought
                                  }
                                  setPreviousRegularTicketsBought={
                                    setPreviousRegularTicketsBought
                                  }
                                  setPreviousEarlyBirdTicketsBought={
                                    setPreviousEarlyBirdTicketsBought
                                  }
                                  regularTicketId={regularTicketId}
                                  earlyBirdTicketId={earlyBirdTicketId}
                                  setRegularTicketId={setRegularTicketId}
                                  setEarlyBirdTicketId={setEarlyBirdTicketId}
                                  eventImgUrl={eventImgUrl}
                                  eventRef={eventRef}
                                  regularTicketAvailable={
                                    regularTicketAvailable
                                  }
                                  earlyBirdTicketAvailable={
                                    earlyBirdTicketAvailable
                                  }
                                  grossSales={grossSales}
                                />
                              </div>
                            )}
                            {page === 7 && (
                              <div
                                className="page_one"
                                data-aos="fade-in"
                                data-aos-duration="1000"
                              >
                                <SuccessPage
                                  eventId={eventId}
                                  setPage={setPage}
                                />
                              </div>
                            )}
                          </div>
                        ) : (
                          <ComingSoon />
                        )}
                      </>
                    ) : (
                      <ComingSoon />
                    )}
                  </>
                ) : (
                  <div className="buyingModel_body">
                    {page === 1 && (
                      <div
                        className="page_one"
                        data-aos="fade-out"
                        data-aos-duration="1000"
                      >
                        {/* {console.log("Hello Team Early Release!")} */}
                        <MemoizedOnboardingOne
                          eventId={eventId}
                          ticketStat={ticketsStatus}
                          availableRegularTicket={regularTicketAvailable}
                          availableEarlyTicket={earlyBirdTicketAvailable}
                          regularTicketPrice={regularTicketAmount}
                          earlyTicketPrice={earlyBirdTicketAmount}
                          setPage={setPage}
                        />
                      </div>
                    )}
                    {page === 2 && (
                      <div
                        className="page_one"
                        data-aos="fade-in"
                        data-aos-duration="1000"
                      >
                        <MemorizedTicketSelectionPage
                          eventId={eventId}
                          eventRef={eventRef}
                          available_regular_ticket={regularTicketAvailable}
                          available_early_ticket={earlyBirdTicketAvailable}
                          regular_ticket_price={regularTicketAmount}
                          early_ticket_price={earlyBirdTicketAmount}
                          setPage={setPage}
                          regularTicketId={regularTicketId}
                          earlyBirdTicketId={earlyBirdTicketId}
                          waitingListRegular={regularTicketWaitingList}
                          waitingListEarlyBird={earlyBirdTicketWaitingList}
                          // Regular and Early Bought
                          regularTicketsBought={regularTicketsBought}
                          earlyBirdTicketsBought={earlyBirdTicketsBought}
                          setRegularTicketsBought={setRegularTicketsBought}
                          setEarlyBirdTicketsBought={setEarlyBirdTicketsBought}
                          // Previous Regular and Early Bought
                          previousRegularTicketsBought={
                            previousRegularTicketsBought
                          }
                          previousEarlyBirdTicketsBought={
                            previousEarlyBirdTicketsBought
                          }
                          setPreviousRegularTicketsBought={
                            setPreviousRegularTicketsBought
                          }
                          setPreviousEarlyBirdTicketsBought={
                            setPreviousEarlyBirdTicketsBought
                          }
                        />
                      </div>
                    )}
                    {page === 3 && (
                      <div
                        className="page_one"
                        data-aos="fade-in"
                        data-aos-duration="1000"
                      >
                        <MemorizedUserInformationPage
                          eventId={eventId}
                          setPage={setPage}
                          setRegularUserInfo={setRegularUserInfo}
                          setEarlyUserInfo={setEarlyUserInfo}
                          regularUserInfo={regularUserInfo}
                          earlyUserInfo={earlyUserInfo}
                          regularTicketsBought={regularTicketsBought}
                          earlyBirdTicketsBought={earlyBirdTicketsBought}
                          previousRegularTicketsBought={
                            previousRegularTicketsBought
                          }
                          previousEarlyBirdTicketsBought={
                            previousEarlyBirdTicketsBought
                          }
                        />
                      </div>
                    )}
                    {page === 4 && (
                      <div
                        className="page_one"
                        data-aos="fade-in"
                        data-aos-duration="1000"
                      >
                        <TermsCondition
                          eventId={eventId}
                          setPage={setPage}
                          eventName={eventName}
                          regularUserInfo={regularUserInfo}
                          earlyUserInfo={earlyUserInfo}
                        />
                      </div>
                    )}

                    {page === 5 && (
                      <div
                        className="page_one"
                        data-aos="fade-in"
                        data-aos-duration="1000"
                      >
                        <ReviewDetails
                          eventId={eventId}
                          setPage={setPage}
                          regularUserInfo={regularUserInfo}
                          earlyUserInfo={earlyUserInfo}
                          regularTicketAmount={regularTicketAmount}
                          earlyBirdTicketAmount={earlyBirdTicketAmount}
                          totalTicketAmount={totalTicketAmount}
                          setTotalTicketAmount={setTotalTicketAmount}
                          regularTicketsBought={regularTicketsBought}
                          earlyBirdTicketsBought={earlyBirdTicketsBought}
                        />
                      </div>
                    )}
                    {/* // ! We can maybe check here for if the ticket is available for the selected number... */}
                    {page === 6 && (
                      <div
                        className="page_one"
                        data-aos="fade-in"
                        data-aos-duration="1000"
                      >
                        <Payment
                          eventId={eventId}
                          setPage={setPage}
                          setShow={setShow}
                          regularUserInfo={regularUserInfo}
                          earlyUserInfo={earlyUserInfo}
                          regularTicketAmount={regularTicketAmount}
                          earlyBirdTicketAmount={earlyBirdTicketAmount}
                          totalTicketAmount={totalTicketAmount}
                          eventName={eventName}
                          regularTicketsBought={regularTicketsBought}
                          earlyBirdTicketsBought={earlyBirdTicketsBought}
                          setEarlyBirdTicketsBought={setEarlyBirdTicketsBought}
                          setRegularTicketsBought={setRegularTicketsBought}
                          regularVaccineProof={regularVaccineProof}
                          earlyVaccineProof={earlyVaccineProof}
                          setRegularUserInfo={setRegularUserInfo}
                          setEarlyUserInfo={setEarlyUserInfo}
                          waitingListRegular={regularTicketWaitingList}
                          waitingListEarlyBird={earlyBirdTicketWaitingList}
                          previousRegularTicketsBought={
                            previousRegularTicketsBought
                          }
                          previousEarlyBirdTicketsBought={
                            previousEarlyBirdTicketsBought
                          }
                          setPreviousRegularTicketsBought={
                            setPreviousRegularTicketsBought
                          }
                          setPreviousEarlyBirdTicketsBought={
                            setPreviousEarlyBirdTicketsBought
                          }
                          regularTicketId={regularTicketId}
                          earlyBirdTicketId={earlyBirdTicketId}
                          setRegularTicketId={setRegularTicketId}
                          setEarlyBirdTicketId={setEarlyBirdTicketId}
                          eventImgUrl={eventImgUrl}
                          eventRef={eventRef}
                          regularTicketAvailable={regularTicketAvailable}
                          earlyBirdTicketAvailable={earlyBirdTicketAvailable}
                          grossSales={grossSales}
                        />
                      </div>
                    )}
                    {page === 7 && (
                      <div
                        className="page_one"
                        data-aos="fade-in"
                        data-aos-duration="1000"
                      >
                        <SuccessPage eventId={eventId} setPage={setPage} />
                      </div>
                    )}
                  </div>
                )}
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
}

function useInterval(callback, delay) {
  const savedCallback = useRef();

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    function tick() {
      savedCallback.current();
    }
    if (delay !== null) {
      let id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
}

function ComingSoon() {
  return (
    <div className="message_Container">
      <img src="/Images/logo.png" alt="" />
      <h1>Tickets will be coming soon!</h1>
      <h2 id="paymentSuccess">
        Please check back later! Hope to see you there.
      </h2>
      {/* <div className="stepOne_container">
        <img src="/Images/logo.png" />
        <h1>Payment Successful!</h1>
        <h2 id="paymentSuccess">
          Thank you for your payment. Please head over to the orders tab to view
          your ticket.
        </h2>
      </div> */}
    </div>
  );
}

function SoldOut() {
  return (
    <div className="message_Container">
      <img src="/Images/logo.png" alt="" />
      <h1>Tickets are sold out!</h1>
      <p>We hope to see you on our next event!</p>
    </div>
  );
}

function OnboardingOne({
  eventId,
  ticketStat,
  availableRegularTicket,
  availableEarlyTicket,
  regularTicketPrice,
  earlyTicketPrice,
  setPage,
}) {
  useEffect(() => {
    try {
      if (ticketStat === true) {
        if (
          (availableRegularTicket <= 0 && availableEarlyTicket <= 0) ||
          (availableRegularTicket === -1 && availableRegularTicket === -1) ||
          (regularTicketPrice === 0 && earlyTicketPrice === 0)
        ) {
          document.getElementById("ticket_selection_btn").style.display =
            "none";
        } else {
          document.getElementById("ticket_selection_btn").style.display =
            "block";
        }
      } else {
        document.getElementById("ticket_selection_btn").style.display = "none";
      }
    } catch (e) {
      // console.log("Couldn't find the button!");
    }
  }, [ticketStat, availableRegularTicket, availableEarlyTicket]);

  return (
    <>
      {availableRegularTicket === -1 && availableEarlyTicket === -1 ? (
        <div className="loading_container">
          {/* <img src="/Images/Event/spinner.svg" alt = "Loading..." /> */}
          <img src={SpinnerSVG} alt="Loading..." id="spinner" />
        </div>
      ) : (
        <>
          <div className="stepOne_container">
            {ticketStat &&
            (availableRegularTicket > 0 || availableEarlyTicket > 0) ? (
              <>
                <img src="/Images/logo.png" alt="logo" />
                <h1>Tickets are Now On Sale</h1>
                {regularTicketPrice !== 0 && (
                  <>
                    {availableRegularTicket > 0 ? (
                      <h3>
                        Individual Tickets - ${regularTicketPrice.toFixed(2)}
                      </h3>
                    ) : (
                      <h3>Individual Tickets - Sold Out</h3>
                    )}
                  </>
                )}

                {earlyTicketPrice !== 0 && (
                  <>
                    {availableEarlyTicket > 0 ? (
                      <h3>
                        Early Bird Tickets - ${earlyTicketPrice.toFixed(2)}
                      </h3>
                    ) : (
                      <h3>Early Bird Tickets - Sold Out</h3>
                    )}
                  </>
                )}

                <h2>Non-Refundable</h2>
                <h2 id="looking_forward">We hope to see you there!</h2>
              </>
            ) : (
              <SoldOut />
            )}
          </div>
        </>
      )}
      <Button
        variant="contained"
        color="primary"
        onClick={() => {
          handleNextPage(setPage);
        }}
        id="ticket_selection_btn"
      >
        Continue
      </Button>
    </>
  );
}

const MemoizedOnboardingOne = React.memo(OnboardingOne);

function TicketSelectionPage({
  eventId,
  eventRef,
  available_regular_ticket,
  available_early_ticket,
  regular_ticket_price,
  early_ticket_price,
  setPage,
  regularTicketId,
  earlyBirdTicketId,
  waitingListRegular,
  waitingListEarlyBird,

  regularTicketsBought,
  earlyBirdTicketsBought,
  setRegularTicketsBought,
  setEarlyBirdTicketsBought,
  previousRegularTicketsBought,
  previousEarlyBirdTicketsBought,
  setPreviousRegularTicketsBought,
  setPreviousEarlyBirdTicketsBought,
}) {
  const [regularNumTicket, setRegularNumTicket] =
    useState(regularTicketsBought);
  const [earlyBirdNumTicket, setEarlyBirdNumTicket] = useState(
    earlyBirdTicketsBought
  );

  const [discountedRegularPrice, setDiscountedRegularPrice] =
    useState(regular_ticket_price);

  const increasePageCount = (e) => {
    if (e.target.id === "plus_regular") {
      //! If we are using the previous waiting list method...
      // We are checking to see if the current regular number of tickets is greater then available regular ticket
      // if (previousRegularTicketsBought === 0) {
      if (regularNumTicket > available_regular_ticket) {
        setRegularNumTicket(available_regular_ticket);
      }
      // We are checking to see if the current regular number of tickets is less or equal then available regular ticket
      else {
        // If available regular ticket is greater or equal to 10 then let it go till 10
        if (available_regular_ticket >= maxTicket) {
          if (regularNumTicket >= 0 && regularNumTicket < maxTicket) {
            setRegularNumTicket(regularNumTicket + 1);
          }
          // Current regular ticket is less then available regular ticket then we set the limit to the max.
        } else {
          if (
            regularNumTicket >= 0 &&
            regularNumTicket < available_regular_ticket
          ) {
            setRegularNumTicket(regularNumTicket + 1);
          }
        }
      }
      // } else {
      //   // if (previousRegularTicketsBought > available_regular_ticket) {
      //   //   if (regularNumTicket < previousRegularTicketsBought) {
      //   //     setRegularNumTicket(regularNumTicket + 1);
      //   //   }
      //   // } else {
      //   //   if (regularNumTicket < available_regular_ticket) {
      //   //     setRegularNumTicket(regularNumTicket + 1);
      //   //   }
      //   // }
      //   if (
      //     regularNumTicket <
      //     previousRegularTicketsBought + available_regular_ticket
      //   ) {
      //     setRegularNumTicket(regularNumTicket + 1);
      //   }
      // }
    } else {
      // ! Updated based on depreciated method for waiting list...
      // if (previousEarlyBirdTicketsBought === 0) {
      if (earlyBirdNumTicket > available_early_ticket) {
        setEarlyBirdNumTicket(available_early_ticket);
      } else {
        if (available_early_ticket >= maxTicket) {
          if (earlyBirdNumTicket >= 0 && earlyBirdNumTicket < maxTicket) {
            setEarlyBirdNumTicket(earlyBirdNumTicket + 1);
          }
        } else {
          if (
            earlyBirdNumTicket >= 0 &&
            earlyBirdNumTicket < available_early_ticket
          ) {
            setEarlyBirdNumTicket(earlyBirdNumTicket + 1);
          }
        }
      }
      // } else {
      //   console.log({ previousEarlyBirdTicketsBought });
      //   console.log({ available_early_ticket });
      //   console.log({ earlyBirdNumTicket });
      //   // if (previousEarlyBirdTicketsBought > available_early_ticket) {
      //   //   if (earlyBirdNumTicket < previousEarlyBirdTicketsBought) {
      //   //     setEarlyBirdNumTicket(earlyBirdNumTicket + 1);
      //   //   }
      //   // } else {
      //   //   if (earlyBirdNumTicket < available_early_ticket) {
      //   //     setEarlyBirdNumTicket(earlyBirdNumTicket + 1);
      //   //   }
      //   // }
      //   if (
      //     earlyBirdNumTicket <
      //     previousEarlyBirdTicketsBought + available_early_ticket
      //   ) {
      //     setEarlyBirdNumTicket(earlyBirdNumTicket + 1);
      //   }
      // }
    }
  };

  const decreasePageCount = (e) => {
    if (e.target.id === "minus_regular") {
      if (previousRegularTicketsBought === 0) {
        if (regularNumTicket > available_regular_ticket) {
          setRegularNumTicket(available_regular_ticket);
        } else {
          if (regularNumTicket > 0 && regularNumTicket <= maxTicket) {
            setRegularNumTicket(regularNumTicket - 1);
          }
        }
      } else {
        if (regularNumTicket > 0) {
          setRegularNumTicket(regularNumTicket - 1);
        }
      }
    } else {
      if (previousEarlyBirdTicketsBought === 0) {
        if (earlyBirdNumTicket > available_early_ticket) {
          setEarlyBirdNumTicket(available_early_ticket);
        } else {
          if (earlyBirdNumTicket > 0 && earlyBirdNumTicket <= maxTicket) {
            setEarlyBirdNumTicket(earlyBirdNumTicket - 1);
          }
        }
      } else {
        if (earlyBirdNumTicket > 0) {
          setEarlyBirdNumTicket(earlyBirdNumTicket - 1);
        }
      }
    }
  };

  const handleSubmitPage = () => {
    const button = document.getElementById("continue_to_userInfo");

    /**
     * ! THIS PART IS GOING TO BE UPDATED - So that it doesn't affect db after making the number of tickets request
     * * We will convert waitingList into in process status so that we know in the future if it works...
     */

    if (button.disabled === false) {
      // If prev is 0 and curr is set to something else

      // If its the first time I am buying anything...
      if (previousRegularTicketsBought === 0 && regularTicketsBought !== 0) {
        // change the available regular tickets to the tickets bought
        var tempValue = available_regular_ticket; // BEFORE: var tempValue = available_regular_ticket - regularTicketsBought;
        var tempWaitingListVal = waitingListRegular + regularTicketsBought;

        updateDoc(eventRef, {
          // RegularTickets: {
          //   price: regular_ticket_price,
          //   ticketsAvailable: tempValue,
          //   waitingList: tempWaitingListVal,
          // },
          RegularTicketWaitingList: increment(regularTicketsBought),
        });
      }

      // If the previous is not 0 and curr is same as prev
      else if (
        previousRegularTicketsBought !== 0 &&
        regularTicketsBought === previousRegularTicketsBought
      ) {
        // just direct the user to the next page
        // console.log("Same as before")
      }
      // If the previous is not 0 and curr is not same as prev
      else if (
        previousRegularTicketsBought !== 0 &&
        regularTicketsBought !== previousRegularTicketsBought
      ) {
        // Add to the database the remaining tickets
        // var remaining = previousRegularTicketsBought; // BEFORE:  var remaining = previousRegularTicketsBought - regularTicketsBought;
        // var tempValue = available_regular_ticket; // BEFORE: var tempValue = available_regular_ticket + remaining;

        // var waitingRemaining =
        //   regularTicketsBought - previousRegularTicketsBought;
        // var tempWaitingListVal = waitingListRegular + waitingRemaining;

        if (regularTicketsBought > previousRegularTicketsBought) {
          // Add to the database the remaining tickets
          updateDoc(eventRef, {
            RegularTicketWaitingList: increment(
              regularTicketsBought - previousRegularTicketsBought
            ),
          });
        } else {
          if (regularTicketsBought === 0) {
            updateDoc(eventRef, {
              RegularTicketWaitingList: increment(
                -previousRegularTicketsBought
              ),
            });
          }
          updateDoc(eventRef, {
            RegularTicketWaitingList: increment(-regularTicketsBought),
          });
        }
      }

      // EARLY BIRD DB

      if (
        previousEarlyBirdTicketsBought === 0 &&
        earlyBirdTicketsBought !== 0
      ) {
        // change the available regular tickets to the tickets bought
        // var tempValue = available_early_ticket; // BEFORE: var tempValue = available_early_ticket - earlyBirdTicketsBought;
        // var tempEarlyVal = waitingListEarlyBird + earlyBirdTicketsBought;
        updateDoc(eventRef, {
          EarlyBirdTicketWaitingList: increment(earlyBirdTicketsBought),
        });
      }
      // If the previous is not 0 and curr is same as prev
      else if (
        previousEarlyBirdTicketsBought !== 0 &&
        earlyBirdTicketsBought === previousEarlyBirdTicketsBought
      ) {
        // just direct the user to the next page
        // console.log("Same as before")
      }
      // If the previous is not 0 and curr is not same as prev
      else if (
        previousEarlyBirdTicketsBought !== 0 &&
        earlyBirdTicketsBought !== previousEarlyBirdTicketsBought
      ) {
        // Add to the database the remaining tickets
        if (earlyBirdTicketsBought > previousEarlyBirdTicketsBought) {
          // console.log("Added more then past")
          updateDoc(eventRef, {
            EarlyBirdTicketWaitingList: increment(
              earlyBirdTicketsBought - previousEarlyBirdTicketsBought
            ),
          });
        } else {
          // console.log("Removed more then past")
          if (earlyBirdTicketsBought === 0) {
            updateDoc(eventRef, {
              EarlyBirdTicketWaitingList: increment(
                -previousEarlyBirdTicketsBought
              ),
            });
          }
          updateDoc(eventRef, {
            EarlyBirdTicketWaitingList: increment(-earlyBirdTicketsBought),
          });
        }
      }

      setPreviousRegularTicketsBought(regularTicketsBought);
      setPreviousEarlyBirdTicketsBought(earlyBirdTicketsBought);
      setPage((page) => page + 1);
    }
  };

  useEffect(() => {
    if (previousRegularTicketsBought === 0 && regularTicketsBought !== 0) {
      if (
        available_early_ticket <= 10 &&
        earlyBirdNumTicket > available_early_ticket
      ) {
        setEarlyBirdNumTicket(available_early_ticket);
      }

      if (
        available_regular_ticket <= 10 &&
        regularNumTicket > available_regular_ticket
      ) {
        setRegularNumTicket(available_regular_ticket);
      }
    }
  }, [available_regular_ticket, available_early_ticket]);

  useEffect(() => {
    if (regularNumTicket >= GROUP_SIZE) {
      setDiscountedRegularPrice(regular_ticket_price - GROUP_DISCOUNT);
    } else {
      setDiscountedRegularPrice(regular_ticket_price);
    }

    const button = document.getElementById("continue_to_userInfo");
    setRegularTicketsBought(regularNumTicket);
    setEarlyBirdTicketsBought(earlyBirdNumTicket);

    if (regularNumTicket > 0 || earlyBirdNumTicket > 0) {
      button.disabled = false;
    } else {
      button.disabled = true;
    }
  }, [regularNumTicket, earlyBirdNumTicket]);

  return (
    <div className="stepTwo_container">
      <h1>Reserve Your Seats</h1>
      <hr />

      {regular_ticket_price !== 0 && (
        <>
          {available_regular_ticket > 0 ? (
            <>
              <div className="ticket_selection_container">
                <div>
                  <img
                    src="/Images/Event/tickets.png"
                    alt=""
                    id="ticketImage"
                  />
                  <div className="ticket_name">
                    <h3>Individual Tickets</h3>
                    <h4>${discountedRegularPrice}</h4>
                  </div>
                </div>
                <div>
                  <span>
                    <img
                      src="/Images/Event/minus_gold.png"
                      alt=""
                      onClick={decreasePageCount}
                      id="minus_regular"
                    />
                    <input
                      type="text"
                      min="0"
                      max="10"
                      value={regularNumTicket}
                      readOnly
                      required
                    />
                    <img
                      src="/Images/Event/plus_gold.png"
                      alt=""
                      onClick={increasePageCount}
                      id="plus_regular"
                    />
                  </span>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="ticket_selection_container">
                <img src="/Images/Event/tickets.png" alt="" id="ticketImage" />
                <div className="ticket_name">
                  <h3>Individual Tickets (Sold Out)</h3>
                  {/* <h4>${regular_ticket_price}</h4> */}
                </div>
              </div>
            </>
          )}
        </>
      )}

      {early_ticket_price !== 0 && (
        <>
          {available_early_ticket > 0 ? (
            <>
              <div className="ticket_selection_container">
                <div>
                  <img
                    src="/Images/Event/tickets.png"
                    alt=""
                    id="ticketImage"
                  />
                  <div className="ticket_name">
                    <h3>Early Bird Tickets</h3>
                    <h4>${early_ticket_price}</h4>
                  </div>
                </div>
                <div>
                  <span>
                    <img
                      src="/Images/Event/minus_gold.png"
                      alt=""
                      onClick={decreasePageCount}
                      id="minus_earlyBird"
                    />
                    <input
                      type="text"
                      min="0"
                      max="10"
                      value={earlyBirdNumTicket}
                      readOnly
                      required
                    />
                    <img
                      src="/Images/Event/plus_gold.png"
                      alt=""
                      onClick={increasePageCount}
                      id="plus_earlyBird"
                    />
                  </span>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="ticket_selection_container">
                <img src="/Images/Event/tickets.png" alt="" id="ticketImage" />
                <div className="ticket_name">
                  <h3>Early Bird Tickets (Sold Out)</h3>
                  {/* <h4>${early_ticket_price}</h4> */}
                </div>
              </div>
            </>
          )}
        </>
      )}
      <div className="buttonContainer" id="buttonContainerReserve">
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            handlePreviousPage(setPage);
          }}
        >
          Back
        </Button>

        <Button
          variant="contained"
          color="primary"
          onClick={handleSubmitPage}
          id="continue_to_userInfo"
        >
          Continue
        </Button>
      </div>
    </div>
  );
}

const MemorizedTicketSelectionPage = React.memo(TicketSelectionPage);

/**
 * @TODO - Add email verification
 *
 */
function UserInformationPage({
  eventId,
  setPage,
  setRegularUserInfo,
  setEarlyUserInfo,
  regularUserInfo,
  earlyUserInfo,
  regularTicketsBought,
  earlyBirdTicketsBought,
}) {
  useEffect(() => {
    console.log("regularUserInfo", regularUserInfo);
    console.log("earlyUserInfo", earlyUserInfo);
    console.log("regularTicketsBought", regularTicketsBought);
    console.log("earlyBirdTicketsBought", earlyBirdTicketsBought);

    if (regularTicketsBought === 0) {
      setRegularUserInfo({});
    } else if (earlyBirdTicketsBought === 0) {
      setEarlyUserInfo({});
    }

    const regularUserInfoLength = Object.keys(regularUserInfo)?.length;
    const earlyUserInfoLength = Object.keys(earlyUserInfo)?.length;

    if (regularUserInfoLength > regularTicketsBought) {
      var tempVal = regularUserInfoLength - regularTicketsBought;

      for (
        var i = regularTicketsBought;
        i < regularTicketsBought + tempVal;
        i++
      ) {
        // console.log("i", i);
        delete regularUserInfo[i];
      }
    }

    if (earlyUserInfoLength > earlyBirdTicketsBought) {
      var tempVal = earlyUserInfoLength - earlyBirdTicketsBought;

      for (
        var i = earlyBirdTicketsBought;
        i < earlyBirdTicketsBought + tempVal;
        i++
      ) {
        // console.log("i", i);
        delete earlyUserInfo[i];
      }
    }
  }, [eventId]);

  const handleOnChangeValues = async (event, location) => {
    const id = event.target.id.split(" ");
    const button = document.getElementById("continue_to_vaccine");
    if (event.target.value !== "") {
      if (location === "regular") {
        setRegularUserInfo((previousRegularInfo) => ({
          ...previousRegularInfo,
          [id[2]]: {
            ...previousRegularInfo[id[2]],
            [id[1]]: event.target.value,
            seenStatus: "Unseen",
          },
        }));
      } else {
        setEarlyUserInfo((previousEarlyInfo) => ({
          ...previousEarlyInfo,
          [id[2]]: {
            ...previousEarlyInfo[id[2]],
            [id[1]]: event.target.value,
            seenStatus: "Unseen",
          },
        }));
      }
    }
    // Deleting the element!
    else {
      if (location === "regular") {
        try {
          delete regularUserInfo[id[2]][id[1]];
          if (Object.keys(regularUserInfo[id[2]])?.length === 0) {
            delete regularUserInfo[id[2]];
          }
        } catch (e) {}

        const valid = await dictionaryValid(
          regularUserInfo,
          regularTicketsBought
        );

        if (valid) {
          button.disabled = false;
        } else {
          button.disabled = true;
        }
      } else {
        try {
          delete earlyUserInfo[id[2]][id[1]];
          if (Object.keys(earlyUserInfo[id[2]])?.length === 0) {
            delete earlyUserInfo[id[2]];
          }
        } catch (e) {}

        const valid = await dictionaryValid(
          earlyUserInfo,
          earlyBirdTicketsBought
        );
        if (valid) {
          button.disabled = false;
        } else {
          button.disabled = true;
        }
      }
    }
  };

  useEffect(() => {
    async function checkValidity() {
      const regular_valid = await dictionaryValid(
        regularUserInfo,
        regularTicketsBought
      );
      const early_valid = await dictionaryValid(
        earlyUserInfo,
        earlyBirdTicketsBought
      );

      const button = document.getElementById("continue_to_vaccine");
      try {
        if (regular_valid && early_valid) {
          button.disabled = false;
        } else {
          button.disabled = true;
        }
      } catch (e) {
        // console.log("Error", e);
      }
    }
    checkValidity();
  }, [regularUserInfo, earlyUserInfo]);

  const dictionaryValid = (dictionary, tickets_bought) => {
    let end_value_count = tickets_bought * 5;
    let count = 0;

    for (let key in dictionary) {
      count += Object.keys(dictionary[key])?.length;
    }

    if (count === end_value_count) {
      return true;
    } else {
      return false;
    }
  };

  const handleSubmitPage = (event) => {
    const button = document.getElementById("continue_to_vaccine");
    if (button.disabled === false) {
      if (regularTicketsBought !== 0 && earlyBirdTicketsBought === 0) {
        const regular_valid = document
          .getElementById("regular_form")
          .checkValidity();
        // console.log(regular_valid);
        if (regular_valid) {
          setPage((page) => page + 1);
        }
      } else if (regularTicketsBought === 0 && earlyBirdTicketsBought !== 0) {
        const early_valid = document
          .getElementById("early_form")
          .checkValidity();
        if (early_valid) {
          setPage((page) => page + 1);
        }
      } else {
        const regular_valid = document
          .getElementById("regular_form")
          .checkValidity();
        const early_valid = document
          .getElementById("early_form")
          .checkValidity();
        if (regular_valid && early_valid) {
          setPage((page) => page + 1);
        }
      }
    }
  };

  const emailVerify = (event) => {
    const email = event.target.value;
    // console.log(event?.target3.validity);
  };

  return (
    <div className="stepThree_container">
      <h1>Information</h1>
      <hr />
      <div className="stepThree_container_body">
        {regularTicketsBought > 0 && (
          <div className="input_sections_collection">
            <h2>Individual Tickets (x{regularTicketsBought}): </h2>
            {Array.from({ length: regularTicketsBought }, (_, i) => (
              <li key={i + 1} className="list_of_input_container">
                <form
                  onChange={(event) => {
                    handleOnChangeValues(event, "regular");
                  }}
                  id="regular_form"
                >
                  <div className="input_selection_container">
                    <h3>Ticket #{i + 1}:</h3>
                    <div className="input_selection_wrapper">
                      <div className="input_selection_name">
                        <label htmlFor={`name ${i}`}>First Name</label>
                        {/* <input
                          id={`name ${i}`}
                          type="text"
                          defaultValue={regularUserInfo[i]?.name}
                          pattern="^[A-Z][a-z][A-Za-z ]*$"
                          required={"required"}
                        /> */}
                        <BuyingModelInput
                          id={`regular name ${i}`}
                          type="text"
                          defaultValue={regularUserInfo[i]?.name}
                          pattern="(^[A-Za-z ]*)$"
                          errorMessage={inputErrorMessage["name"]}
                          required
                        />
                      </div>
                      <div className="input_selection_name">
                        <label htmlFor={`last_name ${i}`}>Last Name</label>
                        {/* <input
                          id={`last_name ${i}`}
                          type="text"
                          defaultValue={regularUserInfo[i]?.last_name}
                        /> */}
                        <BuyingModelInput
                          id={`regular last_name ${i}`}
                          type="text"
                          defaultValue={regularUserInfo[i]?.last_name}
                          pattern="(^[A-Za-z ]*)$"
                          errorMessage={inputErrorMessage["name"]}
                          required
                        />
                      </div>
                    </div>
                    <div className="input_selection_wrapper">
                      <div className="input_selection_name">
                        <label htmlFor={`email ${i}`}>Email</label>
                        {/* <input
                          id={`email ${i}`}
                          type="email"
                          defaultValue={regularUserInfo[i]?.email}
                        /> */}
                        <BuyingModelInput
                          id={`regular email ${i}`}
                          type="email"
                          defaultValue={regularUserInfo[i]?.email}
                          pattern="^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$"
                          errorMessage={inputErrorMessage["email"]}
                          required
                        />
                      </div>
                      <div className="input_selection_name">
                        <label htmlFor={`phone ${i}`}>Phone Number</label>
                        {/* <input
                          id={`phone ${i}`}
                          type="text"
                          defaultValue={regularUserInfo[i]?.phone}
                        /> */}
                        <BuyingModelInput
                          id={`regular phone ${i}`}
                          type="text"
                          defaultValue={regularUserInfo[i]?.phone}
                          pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
                          errorMessage={inputErrorMessage["phoneNumber"]}
                          required
                        />
                      </div>
                    </div>
                  </div>
                </form>
              </li>
            ))}
          </div>
        )}

        {earlyBirdTicketsBought > 0 && (
          <div className="input_sections_collection">
            <h2>Early Bird Tickets (x{earlyBirdTicketsBought}): </h2>

            {Array.from({ length: earlyBirdTicketsBought }, (_, i) => (
              <li key={i + 1} className="list_of_input_container">
                <form
                  onChange={(event) => {
                    handleOnChangeValues(event, "earlyBird");
                  }}
                  id="early_form"
                >
                  <div className="input_selection_container">
                    <h3>Ticket #{i + 1}:</h3>
                    <div className="input_selection_wrapper">
                      <div className="input_selection_name">
                        <label htmlFor={`name ${i}`}>First Name</label>
                        {/* <input
                          id={`name ${i}`}
                          type="text"
                          defaultValue={earlyUserInfo[i]?.name}
                        /> */}
                        <BuyingModelInput
                          id={`early name ${i}`}
                          type="text"
                          className="early_bird_input"
                          defaultValue={earlyUserInfo[i]?.name}
                          pattern="^[A-Z][a-z][A-Za-z ]*$"
                          errorMessage={inputErrorMessage["name"]}
                          ticketType={"earlyBird"}
                          required
                        />
                      </div>
                      <div className="input_selection_name">
                        <label htmlFor={`last_name ${i}`}>Last Name</label>
                        {/* <input
                          id={`last_name ${i}`}
                          type="text"
                          defaultValue={earlyUserInfo[i]?.last_name}
                        /> */}
                        <BuyingModelInput
                          id={`early last_name ${i}`}
                          type="text"
                          defaultValue={earlyUserInfo[i]?.last_name}
                          pattern="^[A-Z][a-z][A-Za-z ]*$"
                          errorMessage={inputErrorMessage["name"]}
                          ticketType={"earlyBird"}
                          required
                        />
                      </div>
                    </div>
                    <div className="input_selection_wrapper">
                      <div className="input_selection_name">
                        <label htmlFor={`email ${i}`}>Email</label>
                        {/* <input
                          id={`email ${i}`}
                          type="email"
                          defaultValue={earlyUserInfo[i]?.email}
                        /> */}
                        <BuyingModelInput
                          id={`early email ${i}`}
                          type="email"
                          defaultValue={earlyUserInfo[i]?.email}
                          pattern="^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$"
                          errorMessage={inputErrorMessage["email"]}
                          ticketType={"earlyBird"}
                          required
                        />
                      </div>
                      <div className="input_selection_name">
                        <label htmlFor={`phone ${i}`}>Phone Number</label>
                        {/* <input
                          id={`phone ${i}`}
                          type="text"
                          defaultValue={earlyUserInfo[i]?.phone}
                        /> */}
                        <BuyingModelInput
                          id={`early phone ${i}`}
                          type="text"
                          defaultValue={earlyUserInfo[i]?.phone}
                          pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
                          errorMessage={inputErrorMessage["phoneNumber"]}
                          ticketType={"earlyBird"}
                          required
                        />
                      </div>
                    </div>
                  </div>
                </form>
              </li>
            ))}
          </div>
        )}
      </div>
      <div className="buttonContainer">
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            handlePreviousPage(setPage);
          }}
        >
          Back
        </Button>
        <Button
          variant="contained"
          color="primary"
          id="continue_to_vaccine"
          onClick={() => {
            handleSubmitPage();
          }}
        >
          Continue
        </Button>
      </div>
    </div>
  );
}

const MemorizedUserInformationPage = React.memo(UserInformationPage);

// TODO: Add validation for the same file name

function VaccineProof({
  eventId,
  setPage,
  regularTicketsBought,
  earlyBirdTicketsBought,
  regularUserInfo,
  earlyUserInfo,
  setRegularUserInfo,
  setEarlyUserInfo,

  setRegularVaccineProof,
  setEarlyVaccineProof,
  regularVaccineProof,
  earlyVaccineProof,
}) {
  const handleSubmitPage = (event) => {
    const button = document.getElementById("continue_to_terms");
    if (button.disabled === false) {
      setPage((page) => page + 1);
    }
  };

  const handleVaccineChange = (event) => {
    const id = event.target.id.split(" ");
    const file = event.target.files[0];

    if (id[0] === "regularVaccine_file") {
      setRegularVaccineProof((regularVaccineProof) => {
        return {
          ...regularVaccineProof,
          [id[1]]: file,
        };
      });
      // setRegularUserInfo((previousRegularInfo) => ({
      //   ...previousRegularInfo,
      //   [id[1]]: {
      //     ...previousRegularInfo[id[1]],
      //     vaccineProof: file,
      //   },
      // }));
    } else {
      setEarlyVaccineProof((earlyVaccineProof) => {
        return {
          ...earlyVaccineProof,
          [id[1]]: file,
        };
      });
      // setEarlyUserInfo((earlyVaccineProof) => ({
      //   ...earlyVaccineProof,
      //   [id[1]]: {
      //     ...earlyVaccineProof[id[1]],
      //     vaccineProof: file,
      //   },
      // }));
    }
  };

  useEffect(() => {
    const regularVaccineProofLength = Object.keys(regularVaccineProof)?.length;
    const earlyVaccineProofLength = Object.keys(earlyVaccineProof)?.length;

    if (regularVaccineProofLength > regularTicketsBought) {
      var tempVal = regularVaccineProofLength - regularTicketsBought;

      for (
        var i = regularTicketsBought;
        i < regularTicketsBought + tempVal;
        i++
      ) {
        delete regularVaccineProof[i];
      }
    }

    if (earlyVaccineProofLength > earlyBirdTicketsBought) {
      var tempVal = earlyVaccineProofLength - earlyBirdTicketsBought;

      for (
        var i = earlyBirdTicketsBought;
        i < earlyBirdTicketsBought + tempVal;
        i++
      ) {
        delete earlyVaccineProof[i];
      }
    }
  }, [eventId]);

  useEffect(() => {
    const button = document.getElementById("continue_to_terms");

    // var regularCount = 0;
    // var earlyCount = 0;

    // for (var i = 0; i < regularTicketsBought; i++) {
    //   if (regularUserInfo[i]?.vaccineProof) {
    //     regularCount++;
    //   }
    // }
    // for (var i = 0; i < earlyBirdTicketsBought; i++) {
    //   if (earlyUserInfo[i]?.vaccineProof) {
    //     earlyCount++;
    //   }
    // }

    // console.log("regular count: ", regularCount);
    // console.log("early count: ", earlyCount);

    // console.log("regularVaccineProof", regularUserInfo?.vaccineProof?.name);

    // console.log("regularTicketsBought", regularTicketsBought);
    // console.log("earlyBirdTicketsBought", earlyBirdTicketsBought);

    // if (regularTicketsBought !== 0 && earlyBirdTicketsBought !== 0) {
    //   console.log(">>>>>>>>>>>>>>>>>>>>>>BOTH NOT ZERO");
    //   if (
    //     regularTicketsBought === regularCount &&
    //     earlyBirdTicketsBought === earlyCount
    //   ) {
    //     button.disabled = false;
    //   } else {
    //     button.disabled = true;
    //   }
    // } else if (regularTicketsBought === 0) {
    //   console.log(">>>>>>>>>>>>>>>>>>>>>>REGULAR TICKET IS 0");
    //   if (earlyBirdTicketsBought === earlyCount) {
    //     button.disabled = false;
    //   } else {
    //     button.disabled = true;
    //   }
    // } else {
    //   console.log(">>>>>>>>>>>>>>>>>>>>>>EARLY TICKET IS 0");
    //   if (regularTicketsBought === regularCount) {
    //     button.disabled = false;
    //   } else {
    //     button.disabled = true;
    //   }
    // }

    if (
      regularTicketsBought !== Object.keys(regularVaccineProof)?.length ||
      earlyBirdTicketsBought !== Object.keys(earlyVaccineProof)?.length
    ) {
      button.disabled = true;
    } else {
      button.disabled = false;
    }
  }, [regularVaccineProof, earlyVaccineProof]);

  return (
    <div className="vaccineProof_container">
      <Button
        variant="contained"
        color="primary"
        onClick={() => {
          handlePreviousPage(setPage);
        }}
      >
        Back
      </Button>
      <h1>Vaccine Proof</h1>
      <hr />
      {Object.keys(regularUserInfo)?.length > 0 &&
        Array.from({ length: Object.keys(regularUserInfo)?.length }, (_, i) => (
          <li key={i + 1} className="list_of_input_container">
            <form id="vaccine_form">
              <h2>{`${regularUserInfo[i]?.name} ${regularUserInfo[i]?.last_name}`}</h2>
              <div className="vaccineProof_container_body">
                <label
                  htmlFor={`regularVaccine_file ${i}`}
                  className="custom_upload"
                >
                  <input
                    type="file"
                    id={`regularVaccine_file ${i}`}
                    accept="image/png, image/jpeg, image/jpg, application/pdf"
                    onChange={handleVaccineChange}
                  />
                  <p>
                    <span>
                      <img
                        src="/Images/Event/file_upload.png"
                        className="upload_file_icon"
                      />
                    </span>
                    Upload your vaccine proof
                  </p>
                </label>
              </div>
              {regularVaccineProof[i] && (
                <h4>Uploaded: {regularVaccineProof[i]?.name}</h4>
              )}
            </form>
          </li>
        ))}

      {Object.keys(earlyUserInfo)?.length > 0 &&
        Array.from({ length: Object.keys(earlyUserInfo)?.length }, (_, i) => (
          <li key={i + 1} className="list_of_input_container">
            <form id="vaccine_form">
              <h2>{`${earlyUserInfo[i]?.name} ${earlyUserInfo[i]?.last_name}`}</h2>
              <div className="vaccineProof_container_body">
                <label
                  htmlFor={`earlyVaccine_file ${i}`}
                  className="custom_upload"
                >
                  <input
                    type="file"
                    id={`earlyVaccine_file ${i}`}
                    accept="image/png, image/jpeg, image/jpg, application/pdf"
                    onChange={handleVaccineChange}
                  />
                  <p>
                    <span>
                      <img
                        src="/Images/Event/file_upload.png"
                        className="upload_file_icon"
                      />
                    </span>
                    Upload your vaccine proof
                  </p>
                </label>
              </div>
              {earlyVaccineProof[i] && (
                <h4>Uploaded: {earlyVaccineProof[i]?.name}</h4>
              )}
            </form>
          </li>
        ))}

      <Button
        variant="contained"
        color="primary"
        onClick={handleSubmitPage}
        id="continue_to_terms"
      >
        Continue
      </Button>
    </div>
  );
}

function TermsCondition({
  eventId,
  setPage,
  eventName,
  regularUserInfo,
  earlyUserInfo,
}) {
  useEffect(() => {
    const button = document.getElementById("continue_to_review");
    // console.log("Regular User Info: ", regularUserInfo);
    // console.log("Early User Info: ", earlyUserInfo);
    button.disabled = true;
  }, [eventId]);

  const handleSubmitPage = (event) => {
    const button = document.getElementById("continue_to_review");
    if (button.disabled === false) {
      setPage((page) => page + 1);
    }
  };

  const handleCheckboxChange = (event) => {
    const button = document.getElementById("continue_to_review");
    if (event.target.checked === true) {
      button.disabled = false;
    } else {
      button.disabled = true;
    }
  };

  return (
    <div className="stepFour_container">
      <h1>Terms and Conditions</h1>
      <hr />
      <div className="stepFour_container_body">
        {/* <input type="textarea" /> */}
        <textarea
          readOnly
          value={`“Attendee” refers to the person that will be attending the event “Legal Guardian” is a reference to the person who is required to sign on behalf of the Attendee should they be below the age of majority and are not able to give legal consent. “Event” means ${eventName}, the event held by Ontario Gujarati Students Association. By signing this event attendee waiver and release of liability form: I confirm that I am above the age of majority, or am the legal guardian/parent of the Attendee and that I understand the terms and conditions written in this waiver and liability release before participating at ${eventName} (the “Event”). I acknowledge the contagious nature of the Coronavirus/COVID-19 and that the Public Health Agency of Canada, Public Health Ontario, Peel Public Health, and many other public health authorities still recommend practicing social distancing. I further acknowledge that the Ontario Gujarati Students Association has put in place preventative measures to reduce the spread of the Coronavirus/COVID-19. I acknowledge that I am not experiencing any symptom of illness such as: Cough Shortness of Breath Difficulty Breathing Fever Chills Repeated Shaking with Chills Muscle Pain Headache Sore Throat New Loss of Taste or Smell Any other COVID-19 related symptom I have not traveled internationally within the last 14 days. I have not traveled to a highly impacted area within Canada in the last 14 days. I do not believe I have been exposed to someone with a suspected and/or confirmed case of the Coronavirus/COVID-19. I have not been diagnosed with Coronavirus/COVID-19 and have not yet been cleared as non-contagious by provincial or local public health authorities. I have received 2 doses of a Canadian Government approved vaccine. I am following all Public Health Agency of Canada, Public Health Ontario, Peel Public Health, and much other public health authority recommended guidelines as much as possible and limiting my exposure to the Coronavirus/COVID-19. I also agree to follow all the safety measures set in place by Ontario Gujarati Students Association regarding COVID-19 protocols, and if at any time do I deem the conditions to be unsafe, or that I am no longer in proper physical condition to further participate in the Event, or if I begin experiencing symptoms of illness, I will immediately discontinue further participation in the activity and inform the figure of authority at the Event. I acknowledge the contagious and evolving nature of COVID-19 and voluntarily assume the risk that I may be exposed to the virus and become affected as a result. I understand the risk of becoming infected may impact members of the Ontario Gujarati Students Association, event guests, and event attendee’s families or personal contacts. As a participant, volunteer, or , I recognize that my participation, involvement, and/or attendance at the Event is voluntary and may result in personal injury (including death) and/or property damage. By attending, observing, or participating in the Event, I acknowledge and assume all risks and dangers associated with my participation and/or attendance at the Event, and I agree that: (a) the Ontario Gujarati Students Association, (b) the property or site owner of the Event, and (c) all past, present and future affiliates, successors, assigns, employees, volunteers, vendors, partners, directors, and officers, of such entities (subsections (a) through (c), collectively, the ("Released Parties"), will not be responsible for any personal injury (including death), property damage, or other loss suffered as a result of my participation in, attendance at, and/or observation of the Event, regardless if any such injuries or losses are caused by the negligence of any of the Released Parties (collectively, the "Released Claims"). By attending and/or participating in the activity, I am deemed to have given a full release of liability to the released parties to the fullest permitted by law. \n \nThis is a statement in which you are informed of a specific risk associated with food allergies. The statement is clear that when you use and/or consume products provided by Ontario Gujarati Student’s Association, you are doing so at your own risk. It is important that you read the below statement before signing (or by a parent/guardian if you are a minor). We wish to advise you that because of the methods in which foods are produced, we cannot guarantee that traces of allergens are not present in the products that you are served. This may include but is not limited to nuts, gluten, eggs, dairy, etc. Clearly, if this presents medical issues for yourself, then you need to be aware and make an informed decision. **Exclusion of Liability** Ontario Gujarati Student’s Association cannot accept responsibility for any death, injury, or other loss suffered or caused by the products provided at ${eventName}. You understand that you are doing so at entirely your own risk and will not hold the Ontario Gujarati Student’s Association responsible.`}
        />
        <div className="terms_condition_buttons">
          <input
            type="checkbox"
            id="terms_and_conditions"
            onChange={handleCheckboxChange}
          />
          <label htmlFor="terms_and_conditions">
            By checking this box, I agree to fullfil all the terms and
            conditions mentioned above.
          </label>
        </div>
      </div>
      <div className="buttonContainer">
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            handlePreviousPage(setPage);
          }}
        >
          Back
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSubmitPage}
          id="continue_to_review"
        >
          Continue
        </Button>
      </div>
    </div>
  );
}

function ReviewDetails({
  eventID,
  setPage,
  regularUserInfo,
  earlyUserInfo,
  regularTicketAmount,
  earlyBirdTicketAmount,
  totalTicketAmount,
  setTotalTicketAmount,
  regularTicketsBought,
  earlyBirdTicketsBought,
}) {
  const [regularTotalAmount, setRegularTicketAmount] = useState(0);
  const [earlyTotalAmount, setEarlyTicketAmount] = useState(0);

  useEffect(() => {
    // console.log("Regular User Info: ", regularUserInfo);
    // console.log("Early User Info: ", earlyUserInfo);

    if (regularTicketsBought >= GROUP_SIZE) {
      console.log(
        "Regular before discount: ",
        regularTicketAmount * regularTicketsBought
      );
      console.log(
        "Regular after discount: ",
        (regularTicketAmount - GROUP_DISCOUNT) * regularTicketsBought
      );
      setTotalTicketAmount(
        (regularTicketAmount - GROUP_DISCOUNT) * regularTicketsBought +
          earlyBirdTicketAmount * earlyBirdTicketsBought
      );
    } else {
      setTotalTicketAmount(
        regularTicketAmount * regularTicketsBought +
          earlyBirdTicketAmount * earlyBirdTicketsBought
      );
    }
    setRegularTicketAmount(regularTicketAmount * regularTicketsBought);
    setEarlyTicketAmount(earlyBirdTicketAmount * earlyBirdTicketsBought);
  }, [eventID]);
  return (
    <div className="review_container">
      <h1>Review</h1>
      <hr />

      {regularTicketsBought > 0 && (
        <div className="ticket_selection_container" id="ticket_review">
          <div>
            <img src="/Images/Event/tickets.png" alt="" />
            <div className="ticket_name">
              <h3>Individual Tickets</h3>
              <h4>
                {regularTicketsBought} x ${regularTicketAmount}
              </h4>
            </div>
          </div>
          <h3>${regularTotalAmount.toFixed(2)}</h3>
        </div>
      )}

      {earlyBirdTicketsBought > 0 && (
        <div className="ticket_selection_container" id="ticket_review">
          <div>
            <img src="/Images/Event/tickets.png" alt="" />
            <div className="ticket_name">
              <h3>Early Bird Tickets</h3>
              <h4>
                {earlyBirdTicketsBought} x ${earlyBirdTicketAmount}
              </h4>
            </div>
          </div>
          <h3>${earlyTotalAmount.toFixed(2)}</h3>
        </div>
      )}

      {/* Checking for the group discount */}
      {/* {regularTicketsBought >= GROUP_SIZE && (
        <div className="ticket_selection_container" id="ticket_review">
          <div>
            <img src="/Images/Event/tickets.png" alt="" />
            <div className="ticket_name">
              <h3>Group Discount</h3>
            </div>
          </div>
          <h3>
            {" "}
            - $
            {(
              (regularTicketAmount - (regularTicketAmount - GROUP_DISCOUNT)) *
              regularTicketsBought
            ).toFixed(2)}
          </h3>
        </div>
      )} */}

      <div className="review_container_body">
        {Object.keys(regularUserInfo)?.length > 0 && (
          <>
            <h3>Individual Tickets Attendees:</h3>
            {Array.from({ length: regularTicketsBought }, (_, i) => (
              <div key={i} className="review_container_body_attendees">
                <h4 id="ticket_value">Ticket #{i + 1}:</h4>
                <h4>
                  Name:{" "}
                  {`${regularUserInfo[i]?.name} ${regularUserInfo[i]?.last_name}`}
                </h4>
                <h4>Email: {regularUserInfo[i]?.email}</h4>
                <h4>Phone: {regularUserInfo[i]?.phone}</h4>
              </div>
            ))}
          </>
        )}
        {Object.keys(earlyUserInfo)?.length > 0 && (
          <>
            <h3>Early Bird Attendees:</h3>
            {Array.from({ length: earlyBirdTicketsBought }, (_, i) => (
              <div key={i} className="review_container_body_attendees">
                <h4 id="ticket_value">Ticket #{i + 1}:</h4>
                <h4>
                  Name:{" "}
                  {`${earlyUserInfo[i]?.name} ${earlyUserInfo[i]?.last_name}`}
                </h4>
                <h4>Email: {earlyUserInfo[i]?.email}</h4>
                <h4>Phone: {earlyUserInfo[i]?.phone}</h4>
              </div>
            ))}
          </>
        )}
      </div>
      <hr />

      <div className="total_amount_container">
        <h3>Order Total: </h3>
        <h3>${totalTicketAmount.toFixed(2)}</h3>
      </div>

      <div className="buttonContainer">
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            handlePreviousPage(setPage);
          }}
        >
          Back
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            setPage((page) => page + 1);
          }}
          id="continue_to_review"
        >
          Continue
        </Button>
      </div>
    </div>
  );
}

function Payment({
  eventId,
  setPage,
  regularUserInfo,
  earlyUserInfo,
  regularTicketAmount,
  earlyBirdTicketAmount,
  totalTicketAmount,
  eventName,
  regularTicketsBought,
  earlyBirdTicketsBought,
  regularVaccineProof,
  earlyVaccineProof,
  setRegularUserInfo,
  setEarlyUserInfo,
  eventRef,
  setShow,

  waitingListRegular,
  waitingListEarlyBird,

  previousRegularTicketsBought,
  previousEarlyBirdTicketsBought,

  regularTicketId,
  earlyBirdTicketId,
  setRegularTicketId,
  setEarlyBirdTicketId,
  eventImgUrl,
  earlyBirdTicketAvailable,
  regularTicketAvailable,
  setPreviousRegularTicketsBought,
  setPreviousEarlyBirdTicketsBought,
  setEarlyBirdTicketsBought,
  setRegularTicketsBought,
  grossSales,
}) {
  // Test number for error: 4242 4242 4242 4184
  const stripe = useStripe();
  const elements = useElements();

  const [succeeded, setSucceeded] = useState(false);
  const [processing, setProcessing] = useState(false);

  const [error, setError] = useState(null);
  const [disabled, setDisabled] = useState(true);

  const [clientSecret, setClientSecret] = useState(true);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [logInfoToDB, setLogInfoToDB] = useState(false);
  const [{ user }, dispatch] = useStateValue();

  const history = useNavigate();

  let totalVaccineProofCount =
    Object.keys(regularVaccineProof)?.length +
    Object.keys(earlyVaccineProof)?.length;

  const [count, setCount] = useState(0);

  const [paymentIntentID, setPaymentIntentID] = useState("");

  useEffect(() => {
    // console.log("Waiting List Regular: ", waitingListRegular);
    // console.log("Waiting List Early Bird: ", waitingListEarlyBird);
    // console.log(
    //   "Previous Regular Tickets Bought: ",
    //   previousRegularTicketsBought
    // );
    // console.log(
    //   "Previous Early Bird Tickets Bought: ",
    //   previousEarlyBirdTicketsBought
    // );

    // console.log("previousRegularTicketsBought", previousRegularTicketsBought);

    const getClientSecret = async () => {
      const response = await axios({
        method: "post",
        // Stripe expects the total in a currencies subunits
        url: `/payments/create?total=${totalTicketAmount * 100}&email=${
          user?.email
        }`,
        headers: {
          "Content-Type": "application/json",
          uid: "eTkBDonhibgyExId7dOek9v8u3h1",
        },
      });
      // console.log("Response: ", response.data);

      setClientSecret(response.data.clientSecret);
    };
    getClientSecret();
  }, [eventId]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setProcessing(true);
    // Random ms wait time to simulate previous payment processing
    const randomWaitTime = Math.floor(Math.random() * 5000) + 2000;
    setTimeout(async () => {
      // Check if the user is buying two tickets
      if (
        previousEarlyBirdTicketsBought > 0 &&
        previousRegularTicketsBought > 0
      ) {
        if (earlyBirdTicketAvailable < previousEarlyBirdTicketsBought) {
          // Early bird ticket not available for the number of tickets selected
          if (earlyBirdTicketAvailable === 0) {
            // Early bird ticket not available
            setError(
              "Early bird tickets sadly sold out while you were in the process of purchasing your ticket. You can still purchase a regular ticket."
            );
          } else {
            setError(
              "Early bird ticket not available for the number of tickets selected! Please select a different number of tickets."
            );
          }
          setDisabled(true);
          setProcessing(false);
          setEarlyUserInfo({});
          setPreviousEarlyBirdTicketsBought(0);
          setEarlyBirdTicketsBought(0);
          setTimeout(() => {
            setPage(1);
          }, 5000);
          return;
        }
        if (regularTicketAvailable < previousRegularTicketsBought) {
          // Regular tickets are not available to purchase the number of tickets selected
          if (regularTicketAvailable === 0) {
            // Early bird ticket not available
            setError(
              "Regular tickets sadly sold out while you were in the process of purchasing your ticket. We are sorry about the inconvenience, but we hope to see you in our next event."
            );
          } else {
            setError(
              "Regular tickets not available for the number of tickets you have selected anymore! Please select a different number of tickets."
            );
          }
          setDisabled(true);
          setProcessing(false);
          setRegularUserInfo({});
          setPreviousRegularTicketsBought(0);
          setRegularTicketsBought(0);
          setTimeout(() => {
            setPage(1);
          }, 5000);
          return;
        }
      } else if (
        previousEarlyBirdTicketsBought > 0 ||
        previousRegularTicketsBought > 0
      ) {
        // Check if the user is buying one ticket
        if (previousEarlyBirdTicketsBought > 0) {
          // Trying to purchase early bird ticket
          if (earlyBirdTicketAvailable < previousEarlyBirdTicketsBought) {
            // Early bird ticket not available for the number of tickets selected
            if (earlyBirdTicketAvailable === 0) {
              // Early bird ticket not available
              setError(
                "Early bird tickets sadly sold out while you were in the process of purchasing your ticket. You can still purchase a regular ticket."
              );
            } else {
              setError(
                "Early bird ticket not available for the number of tickets selected! Please select a different number of tickets."
              );
            }
            setDisabled(true);
            setProcessing(false);
            setEarlyUserInfo({});
            setPreviousEarlyBirdTicketsBought(0);
            setEarlyBirdTicketsBought(0);
            setTimeout(() => {
              setPage(1);
            }, 5000);
            return;
          }
        } else {
          // Trying to purchase regular ticket
          if (regularTicketAvailable < previousRegularTicketsBought) {
            // Regular tickets are not available to purchase the number of tickets selected
            if (regularTicketAvailable === 0) {
              // Early bird ticket not available
              setError(
                "Regular tickets sadly sold out while you were in the process of purchasing your ticket. We are sorry about the inconvenience, but we hope to see you in our next event."
              );
            } else {
              setError(
                "Regular tickets not available for the number of tickets you have selected anymore! Please select a different number of tickets."
              );
            }
            setDisabled(true);
            setProcessing(false);
            setRegularUserInfo({});
            setPreviousRegularTicketsBought(0);
            setRegularTicketsBought(0);
            setTimeout(() => {
              setPage(1);
            }, 5000);
            return;
          }
        }
      } else {
        setDisabled(true);
        setProcessing(false);
        setError(
          "Sadly we are sold out while you were in the process of purchasing your ticket. We are sorry about the inconvenience, but we hope to see you in our next event."
        );
        setEarlyUserInfo({});
        setPreviousEarlyBirdTicketsBought(0);
        setEarlyBirdTicketsBought(0);
        setRegularUserInfo({});
        setPreviousRegularTicketsBought(0);
        setRegularTicketsBought(0);
        setTimeout(() => {
          setPage(1);
        }, 5000);
        return;
      }

      // All the checks have passed
      if (document.getElementById("payment_form").checkValidity() === true) {
        const { paymentIntent, error } = await stripe.confirmCardPayment(
          clientSecret,
          {
            payment_method: {
              card: elements.getElement(CardElement),
              billing_details: {
                name: name,
                email: email,
                phone: phone,
              },
            },
          }
        );
        if (error) {
          setError(error.message);
          setProcessing(false);
          setDisabled(true);
        } else {
          setPaymentIntentID(paymentIntent?.id);
          if (vaccineProofSection) {
            for (let i = 0; i < Object.keys(regularVaccineProof)?.length; i++) {
              let file = regularVaccineProof[i];
              let vaccineRef = ref(
                storage,
                `/Event/${eventName}/Vaccine Proof/${paymentIntent?.id}/${file?.name}`
              );

              const uploadTask = uploadBytesResumable(vaccineRef, file);

              uploadTask.on(
                "state_changed",
                (snapshot) => {},
                (error) => {
                  console.log("Upload error: ", error);
                },
                () => {
                  getDownloadURL(uploadTask.snapshot.ref).then((url) => {
                    setRegularUserInfo((previousRegularInfo) => ({
                      ...previousRegularInfo,
                      [i]: {
                        ...previousRegularInfo[i],
                        vaccineProofUrl: url,
                      },
                    }));
                    setCount((count) => count + 1);
                  });
                }
              );
            }

            for (let i = 0; i < Object.keys(earlyVaccineProof)?.length; i++) {
              let file = earlyVaccineProof[i];
              let vaccineRef = ref(
                storage,
                `/Event/${eventName}/Vaccine Proof/${paymentIntent?.id}/${file?.name}`
              );

              const uploadTask = uploadBytesResumable(vaccineRef, file);

              uploadTask.on(
                "state_changed",
                (snapshot) => {},
                (error) => {
                  console.log("Upload error: ", error);
                },
                () => {
                  getDownloadURL(uploadTask.snapshot.ref).then((url) => {
                    setEarlyUserInfo((previousEarlyInfo) => ({
                      ...previousEarlyInfo,
                      [i]: {
                        ...previousEarlyInfo[i],
                        vaccineProofUrl: url,
                      },
                    }));
                    setCount((count) => count + 1);
                  });
                }
              );
            }
          }
          setLogInfoToDB(true);
        }
      } else {
        setError("Please fill out all required fields.");
      }
    }, randomWaitTime);
  };

  useEffect(() => {
    async function checkStatus() {
      // console.log({ count });
      // console.log({ totalVaccineProofCount });
      if (count === totalVaccineProofCount && logInfoToDB) {
        const collectionRef = doc(
          collection(db, "events", eventId?.id, "Payment Confirm"),
          paymentIntentID
        );

        const userCollectionRef = doc(
          collection(
            db,
            "users",
            user?.uid,
            "Event Tickets",
            eventId?.id,
            "Purchased Tickets"
          ),
          paymentIntentID
        );

        const userCollectionEventDetails = doc(
          collection(db, "users", user?.uid, "Event Tickets"),
          eventId?.id
        );

        const charge_response = await axios({
          method: "post",
          // Stripe expects the total in a currencies subunits
          url: `/payments/charges?paymentInt=${paymentIntentID}`,
          headers: {
            "Content-Type": "application/json",
            uid: "eTkBDonhibgyExId7dOek9v8u3h1",
          },
        });

        const receipt_url =
          charge_response?.data?.charges?.data[0]?.receipt_url;

        setTimeout(async () => {
          await setDoc(userCollectionEventDetails, {
            eventName: eventName,
            eventId: eventId?.id,
            id: userCollectionEventDetails?.id,
            lastBought: serverTimestamp(),
          })
            .then(() => {
              setDoc(collectionRef, {
                regularTicketsBought: regularTicketsBought,
                earlyBirdTicketsBought: earlyBirdTicketsBought,
                regularTicketAmount: regularTicketAmount,
                earlyBirdTicketAmount: earlyBirdTicketAmount,
                totalTicketAmount: totalTicketAmount,
                eventName: eventName,
                paymentID: paymentIntentID,
                receipt_url: receipt_url,
                billing_name: name,
                regularUserInfo: regularUserInfo,
                earlyUserInfo: earlyUserInfo,
                boughtTime: serverTimestamp(),
                eventImgUrl: eventImgUrl,
              })
                .then(() => {
                  setDoc(userCollectionRef, {
                    regularTicketsBought: regularTicketsBought,
                    earlyBirdTicketsBought: earlyBirdTicketsBought,
                    regularTicketAmount: regularTicketAmount,
                    earlyBirdTicketAmount: earlyBirdTicketAmount,
                    totalTicketAmount: totalTicketAmount,
                    eventName: eventName,
                    paymentID: paymentIntentID,
                    receipt_url: receipt_url,
                    billing_name: name,
                    regularUserInfo: regularUserInfo,
                    earlyUserInfo: earlyUserInfo,
                    boughtTime: serverTimestamp(),
                    eventImgUrl: eventImgUrl,
                  });
                })
                .then(() => {
                  updateDoc(eventRef, {
                    // totalTicketAmount
                    grossSales: increment(totalTicketAmount),
                  }).then(() => {
                    updateDoc(eventRef, {
                      // RegularTickets: {
                      //   price: regularTicketAmount,
                      //   ticketsAvailable: regularTicketAvailable - previousRegularTicketsBought,
                      //   waitingList: waitingListRegular - previousRegularTicketsBought,
                      // },
                      RegularTicketsAvailable: increment(
                        -previousRegularTicketsBought
                      ),
                      RegularTicketWaitingList: increment(
                        -previousRegularTicketsBought
                      ),
                    }).then(() => {
                      updateDoc(eventRef, {
                        // EarlyBirdTicket: {
                        //   price: earlyBirdTicketAmount,
                        //   ticketsAvailable: earlyBirdTicketAvailable - previousEarlyBirdTicketsBought,
                        //   waitingList:
                        //     waitingListEarlyBird - previousEarlyBirdTicketsBought,
                        // },
                        EarlyBirdTicketsAvailable: increment(
                          -previousEarlyBirdTicketsBought
                        ),
                        EarlyBirdTicketWaitingList: increment(
                          -previousEarlyBirdTicketsBought
                        ),
                      });
                    });
                  });
                });
            })
            .finally(() => {
              setSucceeded(true);
              setError(null);
              setProcessing(false);
              setPage((page) => page + 1);
            });
        }, Math.random() * (4000 - 500) + 1000);
      }
    }
    checkStatus();
  }, [count, logInfoToDB]);

  const handleChange = (event) => {
    setDisabled(event.empty); //If it is empty go ahead and disable the button
    setError(event.error ? event.error.message : ""); //Error then show the error or show nothing
    if (event.error) {
      setProcessing(false);
      setDisabled(true);
    } else {
      setDisabled(false);
    }
  };

  const handleErrorCheck = (error) => {
    if (error && document.getElementById("payment_form").checkValidity()) {
      setError("");
    }
  };

  return (
    <>
      {processing && (
        <div className="loading_container_payment">
          {/* <img src="/Images/Event/spinner.svg" alt = "Loading..." /> */}
          <img src={SpinnerSVG} alt="Loading..." id="spinner" />
        </div>
      )}
      <div className="payment_container">
        <h1>Payment</h1>
        <hr />
        <div className="payment_container_body">
          <h2>{`${eventName} (x${
            regularTicketsBought + earlyBirdTicketsBought
          })`}</h2>

          <div className="payment_form_container">
            <form
              className="payment_form_wrapper"
              onSubmit={handleSubmit}
              id="payment_form"
              onChange={handleErrorCheck}
            >
              <div className="input_selection_wrapper">
                <div className="input_selection_name">
                  <label htmlFor={`name`}>Name on the Card</label>
                  {/* <input
                    id={`name`}
                    type="text"
                    onChange={(e) => {
                      setName(e.target.value);
                    }}
                  /> */}
                  <BuyingModelInput
                    id={`name`}
                    type="text"
                    onChangeValue={setName}
                    pattern="(^[A-Z][A-Za-z. ]*)$"
                    errorMessage={inputErrorMessage["billingName"]}
                    required
                  />
                </div>
                <div className="input_selection_name">
                  <label htmlFor={`phone`}>Phone Number</label>
                  {/* <input
                    id={`phone`}
                    type="text"
                    onChange={(e) => {
                      setPhone(e.target.value);
                    }}
                  /> */}
                  <BuyingModelInput
                    id={`phone`}
                    type="text"
                    onChangeValue={setPhone}
                    pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
                    errorMessage={inputErrorMessage["phoneNumber"]}
                    required
                  />
                </div>
              </div>
              <div className="input_selection_wrapper">
                <div className="input_selection_name">
                  <label htmlFor={`email`}>Email</label>
                  {/* <input
                    id={`email`}
                    type="text"
                    onChange={(e) => {
                      setEmail(e.target.value);
                    }}
                  /> */}
                  <BuyingModelInput
                    id={`email`}
                    type="email"
                    onChangeValue={setEmail}
                    pattern="^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$"
                    errorMessage={inputErrorMessage["email"]}
                    required
                  />
                </div>
              </div>
              <div className="card_wrapper">
                <label id="card_details">Card Details</label>
                <div className="card_container">
                  {/* Light theme to the CardElement */}
                  <CardElement onChange={handleChange} />
                </div>
              </div>
              <div>
                {error && (
                  <div className="error_container">
                    {/* <img src="/Images/Event/warning.png" /> */}
                    <span>{error}</span>
                  </div>
                )}
              </div>
            </form>
          </div>
        </div>

        <hr />
        <div className="total_amount_container">
          <h3>Order Total: </h3>
          <h3>${totalTicketAmount.toFixed(2)}</h3>
        </div>
        <div className="buttonContainer">
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              handlePreviousPage(setPage);
            }}
          >
            Back
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            id="continue_to_vaccine"
            disabled={processing || disabled || succeeded}
          >
            <span>{processing ? <p>Processing...</p> : "Pay Now"}</span>
          </Button>
        </div>
      </div>
    </>
  );
}

function SuccessPage({ eventId }) {
  return (
    // <div className="success_page">
    <div className="stepOne_container">
      <img src="/Images/logo.png" />
      <h1>Payment Successful!</h1>
      <h2 id="paymentSuccess">
        Thank you for your payment. Please head over to the orders tab to view
        your ticket.
      </h2>
    </div>
  );
}

export default BuyingModel;
